import PropTypes from 'prop-types'

import { TOAST_TYPES } from '@/constants/notificationTypes'

const Icon = ({ type }) => {
  const className = `toast-validation-icon ${type}`

  return (
    <div className={className}>
      <Choose>
        <When condition={type === TOAST_TYPES.success}>
          <img
            alt=''
            className='type--green'
            src={require(`/app/assets/images/checkmark-circle-green.svg`)}
          />
        </When>
        <When condition={type === TOAST_TYPES.error}>
          <img
            alt=''
            src={require(`/app/assets/images/exclamation-circle-red.svg`)}
          />
        </When>
      </Choose>
    </div>
  )
}

export default Icon

Icon.propTypes = { type: PropTypes.string.isRequired }
